import React from 'react';

const LoadingSkeleton = ({ type = 'page' }) => {
    // 1. Full Page Skeleton (for main views like Dashboard, Stats)
    if (type === 'page') {
        return (
            <div className="min-h-screen bg-base p-4">
                {/* Header Skeleton */}
                <div className="max-w-4xl mx-auto mb-8 flex items-center justify-between pt-4">
                    <div className="h-8 w-48 bg-surface-hover/50 rounded-lg animate-pulse" />
                    <div className="h-10 w-10 bg-surface-hover/50 rounded-full animate-pulse" />
                </div>

                {/* Content Grid Skeleton */}
                <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Large Card */}
                    <div className="h-64 bg-surface-hover/30 rounded-2xl animate-pulse md:col-span-2" />

                    {/* Medium Cards */}
                    <div className="h-48 bg-surface-hover/30 rounded-2xl animate-pulse" />
                    <div className="h-48 bg-surface-hover/30 rounded-2xl animate-pulse" />
                    <div className="h-48 bg-surface-hover/30 rounded-2xl animate-pulse" />
                    <div className="h-48 bg-surface-hover/30 rounded-2xl animate-pulse" />
                </div>
            </div>
        );
    }

    // 2. Dashboard Only Skeleton
    if (type === 'dashboard') {
        return (
            <div className="w-full h-full flex flex-col gap-6 p-4">
                <div className="h-12 w-3/4 bg-surface-hover/50 rounded-xl animate-pulse" />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="h-32 bg-surface-hover/30 rounded-2xl animate-pulse" />
                    <div className="h-32 bg-surface-hover/30 rounded-2xl animate-pulse" />
                    <div className="h-32 bg-surface-hover/30 rounded-2xl animate-pulse" />
                </div>
                <div className="h-64 w-full bg-surface-hover/30 rounded-2xl animate-pulse" />
            </div>
        );
    }

    // 3. Text/List Skeleton (for Knowledge Base, Dictionary)
    if (type === 'text') {
        return (
            <div className="min-h-screen bg-base p-4">
                <div className="max-w-3xl mx-auto space-y-6 pt-8">
                    {/* Title */}
                    <div className="h-10 w-1/3 bg-surface-hover/50 rounded-lg animate-pulse mb-8" />

                    {/* List Items */}
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="flex gap-4 p-4 bg-surface-hover/10 border border-surface-hover/20 rounded-xl">
                            <div className="w-12 h-12 rounded-lg bg-surface-hover/30 animate-pulse shrink-0" />
                            <div className="flex-1 space-y-3">
                                <div className="h-4 w-1/4 bg-surface-hover/50 rounded animate-pulse" />
                                <div className="h-3 w-3/4 bg-surface-hover/30 rounded animate-pulse" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // Default Spinner
    return (
        <div className="min-h-screen bg-base flex flex-col items-center justify-center p-4">
            <div className="relative w-16 h-16">
                <div className="absolute top-0 left-0 w-full h-full border-4 border-primary/20 rounded-full"></div>
                <div className="absolute top-0 left-0 w-full h-full border-4 border-primary rounded-full border-t-transparent animate-spin"></div>
            </div>
            <p className="mt-4 text-primary font-bold animate-pulse tracking-widest uppercase text-sm">Loading</p>
        </div>
    );
};

export default LoadingSkeleton;
